import React from 'react';
import { Typography, List, ListItem, Divider, Box, Card } from '@mui/material';
import { ProcessingRunData } from '../../../interfaces/processing';
import { PolicyBase } from '../../../interfaces/policy';
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import Accordion from "@mui/material/Accordion";

interface CustomerProcessingRunsProps {
  run: ProcessingRunData;
  index: number;
}

const CustomerProcessingRuns: React.FC<CustomerProcessingRunsProps> = ({ run, index }) => {
  const runDate = new Date(run.created_at);

  if (run.is_test) {
    return null;
  }

  return (
    <Card key={index} sx={{ padding: '20px', mb: 2, overflow: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Run {runDate.toLocaleString()}
      </Typography>
      <List>
        <ListItem>
          <div style={{
            color: '#4f5256',
            fontSize: '14px'
          }}>
            <div style={{marginBottom: '10px'}}>
              <b>Final Status</b>
            </div>
            <div style={{whiteSpace: 'pre-line'}}>
              {run.final_status ?? 'No Final Status available.'}
            </div>
          </div>
        </ListItem>

        <Divider sx={{ my: 2 }} />

        {run.run_data?.answer_action_data && (
          <>
            <ListItem>
              <div>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                  >
                    <ExpandMoreIcon style={{marginRight: '10px'}} /> Picked Policies
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{paddingLeft: '10px'}}>
                      {run.run_data.answer_action_data.picked_policies &&
                      run.run_data.answer_action_data.picked_policies.length > 0 ? (
                        <ul>
                          {run.run_data.answer_action_data.picked_policies.map(
                            (policy: PolicyBase, policyIndex: number) => (
                              <Box key={policyIndex} mb={2} component="li">
                                <strong>Question:</strong> {policy.question}
                                <br />
                                <strong>Answer:</strong> {policy.answer}
                              </Box>
                            )
                          )}
                        </ul>
                      ) : (
                        'No Picked Policies available.'
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </ListItem>

            <Divider sx={{ my: 2 }} />

            <ListItem>
              <div style={{
                color: '#4f5256',
                fontSize: '14px'
              }}>
                <div style={{marginBottom: '10px'}}>
                  <b>Final Response</b>
                </div>
                <div style={{whiteSpace: 'pre-line'}}>
                  {run.run_data.answer_action_data.final_response?.message ?? 'No Final Response available.'}
                </div>
              </div>
            </ListItem>
          </>
        )}
      </List>
    </Card>
  );
};

export default CustomerProcessingRuns;
